import React from 'react';
import { Form } from 'react-bootstrap';

const InputField = ({ label, name, placeholder, type = 'text', register, errors, rules, readOnly, userRoles }) => {
  if (type === 'checkbox') {
    return (
      <Form.Group controlId={name}>
        <Form.Check
          type="checkbox"
          label={label}
          {...register(name, { ...rules })}
          isInvalid={!!errors?.[name]}
        />
        {errors?.[name] && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {errors[name].message}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    );
  }

  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Label className="mb-1">{label}</Form.Label>
      <Form.Control
        type={type}
        placeholder={placeholder}
        {...register(name, rules)}
        isInvalid={!!errors?.[name]}
        readOnly={readOnly || userRoles}
        autoComplete='off'
      />
      {errors?.[name] && (
        <Form.Control.Feedback type="invalid">
          {errors[name].message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default InputField;